import React, { useMemo, useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import ALoader from "views/pages/manage/common/a-loader";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import "../styles/depositChequeForm.scss";
import { useDepositCheque } from "../../hooks/useDepositCheque";
import { getFormattedAmount } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const inputHeight = "44px";
const inputHeightObj = { height: "44px", width: "100%" };

const normalizeBankName = (name = "") => name.replace("Ltd.", "Limited").trim();

const DepositChequeForm = ({
  totalAmount = 0,
  chequeCount = 0,
  bankAccounts = [],
  selectedReceipts = [],
  businessAreaId,
  refreshReceiptList,
  bankName,
  accountNumber,
}) => {
  const [depositFormState, setDepositFormState] = useState({
    bankName: bankName || null,
    accountNumber: accountNumber || null,
  });
  const [depositSlipNo, setDepositSlipNo] = useState(null);
  const { depositCheque, loading: isSubmitting } = useDepositCheque();

  const rowFormHandler = (value, key) => {
    setDepositFormState((prev) => ({
      ...prev,
      [key]: value,
      ...(key === "bankName" ? { accountNumber: null } : {}), // reset account on bank change
    }));
  };

  const handleChequeDeposit = (accountDetails) => {
    depositCheque(
      {
        selectedReceipts,
        businessAreaId,
        totalAmount: totalAmount,
        accountDetails,
        depositSlipNumber: depositSlipNo,
      },
      refreshReceiptList,
    );
  };

  const bankAccountMap = useMemo(() => {
    return bankAccounts.reduce((acc, item) => {
      const bank = normalizeBankName(item?.description);
      const account = item?.bankAccount;

      if (!bank || !account) return acc;

      if (!acc[bank]) {
        acc[bank] = new Set();
      }

      acc[bank].add(account);
      return acc;
    }, {});
  }, [bankAccounts]);

  /**
   * STEP 2: Bank dropdown options
   */
  const bankOptions = useMemo(() => {
    return Object.keys(bankAccountMap).map((bank) => ({
      label: bank,
      value: bank,
    }));
  }, [bankAccountMap]);

  /**
   * STEP 3: Account dropdown options (dependent)
   */
  const accountOptions = useMemo(() => {
    const selectedBank = depositFormState?.bankName?.value;
    if (!selectedBank || !bankAccountMap[selectedBank]) return [];

    return [...bankAccountMap[selectedBank]].map((acc) => ({
      label: acc,
      value: acc,
    }));
  }, [depositFormState.bankName, bankAccountMap]);

  return (
    <div className="deposit-form">
      {/* HEADER */}
      <div className="df-header">
        <div className="df-title">Count of total cheques</div>
        <div className="df-amount">{chequeCount}</div>
      </div>

      <div className="df-header">
        <div className="df-title">Total amount to be deposited</div>
        <div className="df-amount">{getFormattedAmount(totalAmount)}</div>
      </div>

      {/* FORM */}
      <div>
        <AAutoComplete
          label="Bank name"
          currentValue={depositFormState?.bankName}
          handleChange={(value) => rowFormHandler(value, "bankName")}
          items={bankOptions}
          isMulti={false}
          autoFocus={[]}
          height={inputHeight}
        />

        <AAutoComplete
          label="Account number"
          currentValue={depositFormState?.accountNumber}
          handleChange={(value) => rowFormHandler(value, "accountNumber")}
          items={accountOptions}
          height={inputHeight}
          isMulti={false}
          isDisabled={!depositFormState?.bankName}
        />
        <AInput
        label="Deposit slip number"
          className="df-input"
          placeholder="Enter deposit slip number"
          value={depositSlipNo}
          style={inputHeightObj}
          maxLength={10}
          handler={(value) => setDepositSlipNo(value)}
        />
      </div>

      {/* ACTION */}
      <div className="mt-3">
        <AButton
          className="no-ml-btn"
          variant="primary_filled"
          updatedStyle={{ width: "100%", position: "relative" }}
          disabled={
            !(depositFormState.bankName && depositFormState.accountNumber) ||
            isSubmitting
          }
          onClick={() => handleChequeDeposit(depositFormState)}
        >
          {isSubmitting && <ALoader position="absolute" />} Deposit cheques
        </AButton>
      </div>
    </div>
  );
};

export default DepositChequeForm;
